import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { layerCategory, LayerStandard } from '@core/models/layers.model'

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'filterLayerOnCategory',
})
export class filterLayerOnCategoryPipe implements PipeTransform {
  transform(layers: LayerStandard[], category: layerCategory): LayerStandard[] {
    return layers.filter((layer) => {
      if (category.name === layer.category && layer.category != '') return layer
    })
  }
}
